import React, { ReactElement } from 'react'
import MenuModalComponent from './menuModal/MenuModalComponent'

export default function Modals(): ReactElement {
  return (
    <>
      <MenuModalComponent />
      {/* other components here also */}
    </>
  )
}
